import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import Save from "./save";
import Edit from "./Edit";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m12,21.7c-.3,0-.6-.2-.8-.4l-2.1-3.4-.1-.1h-2c-2,0-3.1,0-3.9-.8s-.8-1.9-.8-3.9v-6c0-2,0-3.1.8-3.9.8-.9,1.9-.9,3.9-.9h10c2,0,3.1,0,3.9.8s.8,1.9.8,3.9v6c0,2,0,3.1-.8,3.9s-1.9.9-3.9.9h-2.1l-2.1,3.4c-.2.3-.5.5-.8.5ZM7,3.8c-1.7,0-2.5,0-2.9.4-.3.3-.3,1.1-.3,2.9v6c0,1.7,0,2.5.4,2.9.4.4,1.1.4,2.9.4h2c.6,0,1.1.3,1.4.8l1.6,2.6,1.7-2.7c.3-.4.7-.7,1.2-.7h2c1.7,0,2.5,0,2.9-.4s.4-1.1.4-2.9v-6c0-1.7,0-2.5-.4-2.9s-1.1-.4-2.9-.4c0,0-10,0-10,0Z"
          stroke-width="0"
        />
        <path
          d="m13.2,11.2c.4,0,.8-.3.8-.7v-.3h-.4c-.7,0-1.2-.4-1.2-1v-.6c0-.5.5-1,1.2-1h.8c.7,0,1.2.4,1.2,1v2c0,1.1-1.1,2-2.4,2,0,0,0-1.4,0-1.4Z"
          stroke-width="0"
        />
        <path
          d="m9.6,10.2h.4v.3c0,.4-.4.7-.8.7v1.3c1.3,0,2.4-.9,2.4-2v-2c0-.5-.5-1-1.2-1h-.8c-.7,0-1.2.4-1.2,1v.7c0,.6.5,1,1.2,1Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
